export const int = (()=>{

    return{
        formatBytes(bytes, decimals = 2) {
            if (!+bytes) return '0 Bytes'
            const kb = 1024,
                  dm = decimals < 0 ? 0 : decimals,
                  sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
                  i = Math.floor(Math.log(bytes) / Math.log(kb))
            return `${parseFloat((bytes / Math.pow(kb, i)).toFixed(dm))} ${sizes[i]}`
        },
        getAge(dateString) {
            const today = new Date(),
                  birthDate = new Date(dateString),
                  age = today.getFullYear() - birthDate.getFullYear(),
                  m = today.getMonth() - birthDate.getMonth()
            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--
            }
            return age
        }

    }
})()
